export enum DistanceUnitEnum {
  M = 'm',
  Km = 'km',
}
